module.exports = "https://img1.huilianyi.com/1/no-print-zh.130d6fffa1.appcore.png";